import api_fabric from "../../api/ApiFabric";

/**
 *
 * @return {BpTask}
 */
const api_daily = function() {
  return api_fabric.getInstance("Missions", true);
};

const missions = {
  namespaced: true,
  state: {
    user_daily_personal: null,
    user_daily_list: null,
  },
  mutations: {
    writeUserDailyTask(state, task_data) {
      state.user_daily_personal = task_data.filter(item => item.type === "personal")[0];

      state.user_daily_list = task_data
        .filter(item => item.type === "common")
        .sort(item => (item.is_complete ? 1 : -1));
    },
  },
  getters: {
    getMissionPersonal(state) {
      return state.user_daily_personal;
    },
    getMissionList(state) {
      return state.user_daily_list;
    },
  },
  actions: {
    getUserDailyTask({ commit }) {
      return new Promise(resolve => {
        api_daily()
          .getUserDailyTask()
          .then(response => {
            if (response.success) {
              commit("writeUserDailyTask", response.success.data.data);
              resolve();
            }
          });
      });
    },
  },
};

export default missions;
